var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTradingView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 19,
    viewBox: "0 0 36 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8688 18.4113H6.69808V7.17074H-0.472656V0H13.8365V18.4113H13.8688ZM28.2103 18.4113H20.0382L27.7258 0H35.8978L28.2103 18.4113ZM20.0059 0C22.267 0 24.1081 1.84114 24.1081 4.10218C24.1081 6.36322 22.267 8.20435 20.0059 8.20435C17.7449 8.20435 15.9038 6.36322 15.9038 4.10218C15.9361 1.84114 17.7449 0 20.0059 0Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingView);
export default __webpack_public_path__ + "static/media/tradingView.b0fd31c38cf931a386baf3cc7e3120eb.svg";
export { ForwardRef as ReactComponent };